// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bulb';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.286 12.967v3.4c0 .3-.12.589-.335.801a1.148 1.148 0 0 1-.808.332H7.857a1.15 1.15 0 0 1-.808-.332 1.129 1.129 0 0 1-.335-.801v-3.4m0 2.266h4.572M9 .5v1.133m-8 6.8h1.143m.571-5.666.838.8M17 8.433h-1.143m-.571-5.666-.838.8M6.714 8.056c.303 0 .594.12.808.332.215.212.335.5.335.801v3.778m2.286 0V9.189c0-.3.12-.589.335-.801.214-.213.505-.332.808-.332' />
    <path d='M6.653 12.967h4.694a5.013 5.013 0 0 0 2.058-1.867c.494-.802.75-1.726.738-2.667a5.169 5.169 0 0 0-1.532-3.58A5.256 5.256 0 0 0 9 3.333a5.256 5.256 0 0 0-3.611 1.52 5.17 5.17 0 0 0-1.533 3.58c-.012.94.244 1.865.739 2.667a5.013 5.013 0 0 0 2.057 1.867z' />
  </g>
);

export const viewBox = '0 0 18 18';
